import React, { useState, useRef, useEffect } from 'react'
import login_bg1 from "../../assets/images/loginside-img.png"
import login_bg2 from "../../assets/images/loginbg2.png"
import login_bg3 from "../../assets/images/loginbg3.png"
import Slider from "react-slick"
import 'slick-carousel/slick/slick.css'
// import 'slick-carousel/slick/slick-theme.css'

const ImageSlider = (props) => {

    const Slides = (props) => {
        return (
            <div className="slide-content">
                {props.text1}
                {props.image}
                {props.text2}
            </div>
        )
    }

    const CustomSlide = ({ imageUrl }) => {
        return (
            <div className="slide-content">
                <img
                    src={imageUrl}
                    alt='Custom Slide'
                    style={{
                        width: '100%',
                        height: 'auto',
                        objectFit: 'contain',
                        objectPosition: 'center'
                    }}
                    onError={(e) => {
                        console.log('Failed to load custom image:', imageUrl)
                        e.target.style.display = 'none'
                    }}
                />
            </div>
        )
    }

    const settings = {
        dots: true,
        infinite: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1500,
        autoplaySpeed: 4000,
        pauseOnHover: false,
        cssEase: "linear"
    }

    const defaultSlides = [
        {
            text1: <h1 className='login-slider-title text-34 font-weight-700 text-primary'>Elevate Your Business To New <span className='text-black'>Heights</span> Of Productivity </h1>,
            image: <img className="d-none d-lg-block" src={login_bg1} alt='Login' />,
            text2: <p className="login-slider-dis mb-0 text-18 font-weight-500">Consolidate and replace multiple apps with one centralized platform. Let Bizcompass handle everything.</p>
        },
        {
            text1: <h1 className='login-slider-title text-34 font-weight-700 text-primary'>'Take your Business to'<span className='text-black'> Next level</span> With BIZCOMPASS<sup>®</sup></h1>,
            image: <img className="d-none d-lg-block" src={login_bg2} alt='Login' />,
            text2: <p className="login-slider-dis mb-0 text-18 font-weight-500">Forget about dealing with the stress and confusion of the hiring process. Simplify it with Bizcompass.</p>
        },
        {
            text1: <h1 className='login-slider-title text-34 font-weight-700 text-primary'><span className='text-black'></span>Redefine Your Organization with BIZCOMPASS<sup>®</sup></h1>,
            image: <img className="d-none d-lg-block" src={login_bg3} alt='Login' />,
            text2: <p className="login-slider-dis mb-0 text-18 font-weight-500">Bizcompass enables you to concentrate on excelling at what you do best to run your business successfully.</p>
        }
    ]

    try {
        return (
            <>
                <Slider {...settings}>
                    {/* Show custom images if available, otherwise show default slides */}
                    {props.sliderImages && props.sliderImages?.length > 0 ? (
                        props.sliderImages?.map((imageUrl, index) => (
                            <CustomSlide key={index} imageUrl={imageUrl.url} />
                        ))
                    ) : (
                        defaultSlides?.map((slide, index) => (
                            <Slides
                                key={index}
                                text1={slide.text1}
                                image={slide.image}
                                text2={slide.text2}
                            />
                        ))
                    )}
                </Slider>
            </>
        )
    } catch (e) {
        console.log(e)
        return <></>
    }
}

export default React.memo(ImageSlider)